'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementUtil = require('../elementUtil');

var _BoardIcon = require('../board/boardIcon/BoardIcon');

var _BoardIcon2 = _interopRequireDefault(_BoardIcon);

var _EditableTitle = require('../../components/editableTitle/EditableTitle');

var _EditableTitle2 = _interopRequireDefault(_EditableTitle);

var _gridUtils = require('../../utils/grid/gridUtils');

var _boardConstants = require('../../../common/boards/boardConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Utils


// Components
// Lib
var iconData = Immutable.Map({ fetching: true });

var AliasLoading = function AliasLoading(props) {
    return _react2.default.createElement(
        'div',
        { id: (0, _elementUtil.getDomElementId)(props.element.get('id')), className: (0, _elementUtil.elementClassNames)('Board', props),
            style: (0, _gridUtils.getElementStyle)(_boardConstants.DEFAULT_BOARD_WIDTH, props.gridSize, props.inList) },
        _react2.default.createElement(
            'div',
            { className: 'board-content' },
            _react2.default.createElement(_BoardIcon2.default, { size: 8, icon: iconData }),
            _react2.default.createElement(_EditableTitle2.default, null)
        )
    );
};

AliasLoading.propTypes = {
    element: _propTypes2.default.object.isRequired,
    gridSize: _propTypes2.default.number.isRequired,
    inList: _propTypes2.default.string,
    isSelected: _propTypes2.default.bool,
    isEditing: _propTypes2.default.bool,
    isHovered: _propTypes2.default.bool,
    isDragging: _propTypes2.default.bool,
    className: _propTypes2.default.string
};

exports.default = AliasLoading;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/alias/AliasLoading.js
// module id = 1950
// module chunks = 0